import React from "react";
import { Box, Stack } from "@mui/material";
import { PostsPromoListFacade } from "./PostsPromoListFacade";
import { usePostListModalStore } from "../../Components/Modals/PostListModal/PostListModalStore";
import { ButtonContainer } from "./PostsPromoListFeedEntryComponent.styles";
import { TippspielLinkoutButton } from "@shared/Components/Tippspiel/TippspileLinkoutButton/TippspielLinkoutButton";
import { PostType } from "../../Components/Post/Post.types";

export function PostsPromoListFeedEntryComponent({
    posts,
}: {
    posts: PostType[];
}) {
    const { setIsPostListModalOpen } = usePostListModalStore();

    return (
        <Stack
            component={"div"}
            width={"100%"}
            sx={{
                backgroundColor: "inherit",
            }}
        >
            <Box padding={"0 16px"}>
                <PostsPromoListFacade posts={posts} />
            </Box>
            <ButtonContainer>
                <TippspielLinkoutButton
                    text={"zur Community"}
                    onClick={() => setIsPostListModalOpen(true)}
                />
            </ButtonContainer>
        </Stack>
    );
}
